import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { Table, Row, Col } from 'reactstrap'
import LayoutTitle from 'teleporters/LayoutTitle'
import PageTitle from 'components/common/PageTitle'
import { Loading } from 'components/common/Loading'
import { Query } from 'generated/types'
import { useSession } from 'components/auth/Session'
import { Redirect } from 'react-router-dom'
import {
  SecondaryCard, SecondaryCardBody, SecondaryCardTitle, SecondaryCardSubtitle,
} from 'components/charts/ChartCard'
import { DateTime } from 'luxon'

export const QCS_QUERY = gql`
  query QCS {
    qcs
  }
`

export const QCStatsPage: React.FC = () => {
  const { data, loading } = useQuery<Query>(QCS_QUERY)
  const session = useSession()

  if (session.user?.tenant?.slug !== 'quorum-control') {
    return <Redirect to="/" />
  }

  if (loading) {
    return <Loading />
  }

  const stats = JSON.parse(data?.qcs || '{}')
  const sortedTenants = (stats.tenants || []).sort((a: any, b: any) => {
    return DateTime.fromISO(b.createdAt).toMillis() - DateTime.fromISO(a.createdAt).toMillis()
  })

  return (
    <>
      <LayoutTitle.Source>
        <PageTitle>QCStatsPage</PageTitle>
      </LayoutTitle.Source>

      <Row>
        <Col>
          <SecondaryCard>
            <SecondaryCardBody className="rounded-soft">
              <SecondaryCardTitle>{stats.tenantCount}</SecondaryCardTitle>
              <SecondaryCardSubtitle>Customer count</SecondaryCardSubtitle>
            </SecondaryCardBody>
          </SecondaryCard>
        </Col>
        <Col>
          <SecondaryCard>
            <SecondaryCardBody className="rounded-soft">
              <SecondaryCardTitle>{stats.userCount}</SecondaryCardTitle>
              <SecondaryCardSubtitle>User count</SecondaryCardSubtitle>
            </SecondaryCardBody>
          </SecondaryCard>
        </Col>
        <Col>
          <SecondaryCard>
            <SecondaryCardBody className="rounded-soft">
              <SecondaryCardTitle>{stats.checkinCount}</SecondaryCardTitle>
              <SecondaryCardSubtitle>Checkin count</SecondaryCardSubtitle>
            </SecondaryCardBody>
          </SecondaryCard>
        </Col>
      </Row>
      <Row className="pt-5">
        <Col>
          <Table>
            <thead>
              <tr>
                <th>Org name</th>
                <th>Created at</th>
                <th>Admins</th>
                <th>Checkin Count</th>
                <th>7-day Checkin Count</th>
                <th>ID</th>
                <th>Slug</th>
              </tr>
            </thead>
            <tbody>
              { sortedTenants.map((t: any) => (
                <tr key={t.id}>
                  <td>{ t.name }</td>
                  <td>{ DateTime.fromISO(t.createdAt).toLocaleString(DateTime.DATETIME_SHORT) }</td>
                  <td>{ (t.admins || []).map((a: string) => <>{a}<br /></>) }</td>
                  <td>{ t.checkinCount }</td>
                  <td>{ t.recentCheckinCount }</td>
                  <td>{ t.id }</td>
                  <td>{ t.slug }</td>
                </tr>
              )) }
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  )
}

export default QCStatsPage
